module.exports = __webpack_public_path__ + "static/img/pexels-amirali-beigi-231365-792326.fa65598.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-amirali-beigi-231365-792326.webp
// module id = g2AW
// module chunks = 0